import { __extends, __rest, __assign } from 'tslib';
import { Children, cloneElement, PureComponent } from 'react';
import { classNames, analyticsTracker } from 'uitk-react-utils';

var UitkLinkThemeMap = [
    ['default', 'default'],
    ['inverse', 'inverse']
];
var UitkLinkThemes = new Map(UitkLinkThemeMap);
var UitkLinkSizeMap = [
    ['small', 'small'],
    ['medium', 'medium'],
    ['large', 'large']
];
var UitkLinkSizes = new Map(UitkLinkSizeMap);
var UitkLinkAlignMap = [
    ['left', 'left'],
    ['center', 'center'],
    ['right', 'right']
];
var UitkLinkAligns = new Map(UitkLinkAlignMap);

var UitkLink = /** @class */ (function (_super) {
    __extends(UitkLink, _super);
    function UitkLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkLink.prototype.render = function () {
        var _a, _b;
        var _c = this.props, children = _c.children, className = _c.className, align = _c.align, theme = _c.theme, inline = _c.inline, noWrap = _c.noWrap, analytics = _c.analytics, size = _c.size, disabled = _c.disabled, props = __rest(_c, ["children", "className", "align", "theme", "inline", "noWrap", "analytics", "size", "disabled"]);
        var childrenArray = Children.toArray(children);
        var firstChild = childrenArray[0];
        var childClassName = classNames('uitk-link', className, (_a = {},
            _a["uitk-link-align-" + align] = align,
            _a['uitk-link-theme-inverse'] = theme === 'inverse',
            _a['uitk-link-no-wrap'] = noWrap,
            _a['uitk-link-layout-inline'] = inline,
            _a['uitk-link-layout-default'] = !inline,
            _a["uitk-link-" + size] = size && UitkLinkSizes.get(size),
            _a['uitk-link-disabled'] = !!disabled,
            _a));
        var linkChildren = firstChild.props.children;
        var linkIconClassName = classNames("uitk-link-icon-" + size, (_b = {},
            _b['uitk-link-inverse-icon'] = theme === 'inverse',
            _b));
        var newChildren = [];
        var disabledButton = disabled && (firstChild === null || firstChild === void 0 ? void 0 : firstChild.type) === 'button';
        Children.map(linkChildren, function (child) {
            var _a;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'UitkIcon') {
                newChildren.push(cloneElement(child, {
                    className: linkIconClassName
                }));
            }
            else {
                newChildren.push(child);
            }
        });
        if (!props.onClickCapture && analytics) {
            props.onClickCapture = analyticsTracker.bind(this, analytics);
        }
        var decoratedChild = cloneElement(firstChild, __assign(__assign({ analytics: analytics, children: newChildren, className: childClassName }, props), (disabledButton && {
            tabIndex: -1,
            disabled: true
        })));
        return decoratedChild;
    };
    UitkLink.displayName = 'UitkLink';
    UitkLink.defaultProps = {
        align: UitkLinkAligns.get('left'),
        inline: false,
        noWrap: false,
        size: UitkLinkSizes.get('medium'),
        theme: UitkLinkThemes.get('default')
    };
    return UitkLink;
}(PureComponent));

export { UitkLink };
